/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./html-snippet.m.css";

class HtmlSnippet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: ""
    };
  }

  componentDidMount() {
    this.props.bannerSource && this.getBannerData();
  }

  componentDidUpdate(prevProp) {
    if (prevProp.bannerSource !== this.props.bannerSource) {
      this.getBannerData();
    }
  }

  async getBannerData() {
    const url = `/api/v1/custom-urls/${encodeURIComponent(this.props.bannerSource)}`;
    const bannerData = await (await fetch(url)).json();
    this.setState({
      bannerData: get(bannerData, ["page", "content"], "")
    });
  }

  render() {
    if (!this.state.bannerData) {
      return null;
    }
    return <div styleName="snippet-wrapper" dangerouslySetInnerHTML={{ __html: this.state.bannerData }} />;
  }
}
HtmlSnippet.propTypes = {
  bannerSource: PropTypes.string
};

export { HtmlSnippet };
